import { ReactElement, ReactNode } from 'react';

interface CaseProps<T> {
    value?: T | T[];
    default?: boolean;
    children: ReactNode;
}

interface SwitchProps<T> {
    value: T;
    children: ReactElement<CaseProps<T>> | ReactElement<CaseProps<T>>[];
}

export const Switch = <T,>({ value, children }: SwitchProps<T>): ReactNode => {
    const childrenArray = Array.isArray(children) ? children : [children];

    const result = childrenArray.find((child) => {
        const caseValue = child.props.value;

        if (Array.isArray(caseValue)) {
            return caseValue.includes(value);
        }

        return caseValue === value;
    });

    const defaultResult = childrenArray.find((child) => child.props.default) || null;
    return result || defaultResult;
};

export const Case = <T,>({ children }: CaseProps<T>): ReactNode => children;